<template>
  <div
    id="kt_modal_conta_editar"
    ref="kt_modal_conta_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idConta === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Conta
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Conta
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarConta', false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div class="col-lg-2 fv-row mb-4">
              <label class="form-label">Código</label>
              <input
                id="txtCodigo"
                type="text"
                class="form-control mb-2"
                v-model="data.id"
                disabled
              />
            </div>
            <div class="col-lg-4 fv-row mb-4">
              <label class="form-label">Plano de conta</label>
              <input
                id="txtConta"
                type="text"
                class="form-control mb-2"
                v-model="data.conta"
                disabled
              />
            </div>
            <div class="d-flex align-self-end mb-7 mb-lg-10 col-auto">
              <div class="form-check form-check-custom form-check-sm">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="data.fixo"
                  id="ckFixo"
                  tabindex="-1"
                />
                <label class="form-check-label pt-2" for="ckFixo">
                  <h6>Fixo</h6>
                </label>
              </div>
            </div>
            <div class="d-flex align-self-end mb-7 mb-lg-10 col-auto">
              <div class="form-check form-check-custom form-check-sm">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="data.receita_dre"
                  id="ckReceitaDRE"
                  tabindex="-1"
                />
                <label class="form-check-label pt-2" for="ckReceitaDRE">
                  <h6>DRE</h6>
                </label>
              </div>
            </div>
            <div class="d-flex align-self-end mb-7 mb-lg-10 col-auto">
              <div class="form-check form-check-custom form-check-sm">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="data.grupo_mae"
                  id="ckGrupoMae"
                  tabindex="-1"
                />
                <label class="form-check-label pt-2" for="ckGrupoMae">
                  <h6>Grupo Mãe</h6>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 fv-row mb-4">
              <label class="required form-label">Descrição</label>
              <input
                id="txtDescricaoConta"
                type="text"
                class="form-control mb-2"
                placeholder="Descrição da conta"
                maxlength="75"
                v-model="data.descricao"
                v-on:keyup.enter="nextFocus(`btnConfirmarConta`)"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["descricao"] }}
              </div>
            </div>
            <div class="col-lg-4 fv-row mb-4">
              <label class="form-label">Resultado</label>
              <select
                id="spResultado"
                class="form-select"
                v-model="data.resultado"
              >
                <option value="Receita">Receita</option>
                <option value="Despesa">Despesa</option>
                <option value="Ativo">Ativo</option>
                <option value="Passivo">Passivo</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarConta', false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            id="btnConfirmarConta"
            @click="confirmarConta()"
            v-bind:data-kt-indicator="this.loadingConta ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingConta">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["cancelarConta", "confirmarConta"],
  components: {},
  props: {
    idConta: { type: Number, required: true },
    conta: { type: Object, required: false },
  },
  methods: {
    async confirmarConta() {
      this.errosValidacao = [];
      this.loadingConta = true;
      this.data.fixo = this.$utils.booleanToString(this.data.fixo);
      this.data.receita_dre = this.$utils.booleanToString(
        this.data.receita_dre
      );
      this.data.grupo_mae = this.$utils.booleanToString(this.data.grupo_mae);
      if (this.idConta === 0) {
        this.data.guid = this.$utils.generateUuidv4();
        try {
          var filterOData = "";
          if (this.data.conta != "") {
            filterOData =
              "&$filter=startswith(conta,'" + this.data.conta + ".')";
          }
          var ret = await this.$store.dispatch(
            "conta/getContaOData",
            "?$select=conta&$orderby=conta desc&$top=1" + filterOData
          );
          if (ret.value !== null && ret.value.length > 0) {
            var ultConta = ret.value[0].conta;
            if (this.data.conta != "") {
              var grupoMae = this.data.conta;
              ultConta = ultConta.substring(
                ultConta.length - 4,
                ultConta.length
              );
              this.data.conta = parseInt(ultConta) + 1;
              this.data.conta =
                grupoMae + "." + this.data.conta.toString().padStart(4, "0");
            } else {
              if (ultConta.length > 4) {
                ultConta = ultConta.substring(0, 4);
              }
              this.data.conta = parseInt(ultConta) + 1;
              this.data.conta = this.data.conta.toString().padStart(4, "0");
            }
          } else {
            if (this.data.conta != "") {
              this.data.conta = this.data.conta + ".0001";
            } else {
              this.data.conta = "0001";
            }
          }
          await this.cadastrarConta();
        } catch (error) {
          this.errosGerais = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch("conta/putConta", this.data);
          if (retPut.Success === true) {
            toast.success("Conta alterada com sucesso!", { timeout: 3000 });
            this.$emit("confirmarConta");
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }

      this.data.fixo = this.$utils.stringToBoolean(this.data.fixo);
      this.data.receita_dre = this.$utils.stringToBoolean(
        this.data.receita_dre
      );
      this.data.grupo_mae = this.$utils.stringToBoolean(this.data.grupo_mae);
      this.loadingConta = false;
    },
    async cadastrarConta() {
      try {
        var ret = await this.$store.dispatch("conta/postConta", this.data);
        if (ret.Success === true) {
          toast.success("Conta cadastrada com sucesso!", { timeout: 3000 });
          this.$emit("confirmarConta");
        }
      } catch (error) {
        if (this.conta === null) {
          this.data.conta = "";
        } else {
          this.data.conta = this.conta.conta;
        }
        this.errosValidacao = error;
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    this.errosValidacao = [];
    document.getElementById("spResultado").setAttribute("disabled", true);
    if (this.idConta === 0) {
      if (this.conta === null) {
        document.getElementById("spResultado").removeAttribute("disabled");
        this.data = {
          id: 0,
          conta: "",
          descricao: "",
          resultado: "Receita",
          fixo: false,
          receita_dre: false,
          grupo_mae: false,
          guid: "",
        };
      } else {
        this.data = {
          id: this.conta.id,
          conta: this.conta.conta,
          descricao: "",
          resultado: this.conta.resultado,
          fixo: this.$utils.stringToBoolean(this.conta.fixo),
          receita_dre: this.$utils.stringToBoolean(this.conta.receita_dre),
          grupo_mae: this.$utils.stringToBoolean(this.conta.grupo_mae),
          guid: "",
        };
      }
    } else {
      this.data = {
        id: this.conta.id,
        conta: this.conta.conta,
        descricao: this.conta.descricao.replace(this.conta.conta + " - ", ""),
        resultado: this.conta.resultado,
        fixo: this.$utils.stringToBoolean(this.conta.fixo),
        receita_dre: this.$utils.stringToBoolean(this.conta.receita_dre),
        grupo_mae: this.$utils.stringToBoolean(this.conta.grupo_mae),
        guid: this.conta.guid,
      };
    }

    setTimeout(() => {
      this.nextFocus("txtDescricaoConta");
    }, 800);
  },
  data() {
    return {
      errosValidacao: [],
      loadingConta: false,
      data: {},
    };
  },
};
</script>

<style></style>
